import request from '@/utils/request'

const url = 'admin/site.site'
/**
 * 门店管理接口API
 */

const api = {
  Query(data) {
    return request({
      url: `${url}/list`,
      method: 'post',
      data
    })
  },

  /**
     * 删除Site
     * @returns
     */
  Delete(data) {
    return request({
      url: `${url}/destroy`,
      method: 'post',
      data
    })
  },

  /**
     * 详情Site
     * @returns
     */
  Detail(id) {
    return request({
      url: `${url}/detail`,
      method: 'post',
      params: { id }
    })
  },

  /**
     * 编辑Site
     * @returns
     */
  Update(data) {
    return request({
      url: `${url}/createOrUpdate`,
      method: 'post',
      data
    })
  },

  /**
     * 添加Site
     * @returns
     */
  Create(data) {
    return request({
      url: `${url}/createOrUpdate`,
      method: 'post',
      data
    })
  },

  /**
   * 更改Site数据
   * @returns
   */
  ChangeStatus(data) {
    return request({
      url: `${url}/editOpenStatus`,
      method: 'post',
      data
    })
  },
  getList(data) {
    return request({
      url: `${url}/getList`,
      method: 'post',
      data
    })
  }

}

export default api
